
Greenmile.Checks = Greenmile.Checks || {};
Greenmile.Checks.EventCheck = Greenmile.Checks.EventCheck || {};

Greenmile.Checks.EventCheck.RouteOutOfSequence = {

  template() {
    return {
      tag: 'div',
      items: [
        {
          items: [
            {
              tag: 'label',
              items: [
                {
                  tag: 'span',
                  html: '',
                  attributes: {
                    class: 'i18nResource',
                    id: 'radiusLabel',
                  },
                },
              ],
              attributes: {
                class: 'control-label',
                for: 'checkAllStops',
              },
            },
            {
              items: [
                {
                  tag: 'input',
                  attributes: {
                    type: 'checkbox',
                    id: 'check_all_stops',
                    class: 'modelAttribute checkbox',
                  },
                },
                {
                  tag: 'span',
                  html: Monet.I18n.getResourcesByKey('event.check.routeOutOffSequence.checkAllStops'),
                  attributes: {
                    style: 'margin-left: 5px'
                  }
                }
              ],
              attributes: {
                class: 'controls',
              },
            },
          ],
          attributes: {
            class: 'control-group',
          },
        },
      ],
    };
  },

  assignParameter(jsonParam) {
    if(jsonParam) {
      jsonParam = JSON.parse(jsonParam);
      const checkbox = document.querySelector('#check_all_stops');
      checkbox.checked = jsonParam.checkAllStops;
    }
  },

  retrieveParameter() {
    const checkAllStops = document.querySelector('#check_all_stops');
    const checkbox = checkAllStops && checkAllStops.checked;

    return JSON.stringify({
      checkAllStops: checkbox,
    });
  },

};
